import { shortEnglishHumanizer } from '../utils/humanizer';

export const useDurationHumananizer = (duration: number) => {
  const durationText = shortEnglishHumanizer(duration * 60 * 1000, {
    units: ['mo', 'd', 'h', 'm'],
  });

  return durationText;
};
